import { Account } from '../../Model/Account';
import { AccountRepository, CreateAccountDTO } from '../Repositories/AccountRepository';
import { appendSuffixIfMissing, stripSuffix } from '../../../../Utils/usernameSuffix';

export class CreateAccountUseCase {
  constructor(private readonly repo: AccountRepository) {}

  execute(cmd: CreateAccountDTO): Promise<Account> {
    const optimisticAccount: Account = {
      id: Date.now(),
      username: stripSuffix(cmd.username),
      name: cmd.name,
      grade: cmd.grade,
      parent: cmd.parent,
      memo: cmd.memo,
      createdAt: new Date().toISOString(),
    };

    const toSave: CreateAccountDTO = {
      ...cmd,
      username: appendSuffixIfMissing(cmd.username),
    };

    return this.repo
      .createAccount(toSave)
      .then(account => ({ ...account, username: stripSuffix(account.username) }))
      .catch(err => Promise.reject(err));
  }
}
